'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    '@global': {
      '.emoji-mart, .emoji-mart *': {
        boxSizing: 'border-box',
        lineHeight: '1.15'
      },
      '.emoji-mart': {
        fontFamily: '-apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif',
        fontSize: 16,
        display: 'inline-block',
        color: '#222427',
        border: '1px solid #d9d9d9',
        borderRadius: 5,
        background: '#fff'
      },
      '.emoji-mart .emoji-mart-emoji': {
        padding: 6
      },
      '.emoji-mart-bar': {
        border: '0 solid #d9d9d9'
      },
      '.emoji-mart-bar:first-child': {
        borderBottomWidth: 1,
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5
      },
      '.emoji-mart-bar:last-child': {
        borderTopWidth: 1,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5
      },
      '.emoji-mart-anchors': {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: '0 6px',
        color: '#858585',
        lineHeight: '0'
      },
      '.emoji-mart-anchor': {
        position: 'relative',
        display: 'block',
        flex: '1 1 auto',
        textAlign: 'center',
        padding: '12px 4px',
        overflow: 'hidden',
        transition: 'color .1s ease-out'
      },
      '.emoji-mart-anchor:hover, .emoji-mart-anchor-selected': {
        color: '#464646'
      },
      '.emoji-mart-anchor-selected .emoji-mart-anchor-bar': {
        bottom: '0'
      },
      '.emoji-mart-anchor-selected': {
        color: theme.primaryColor + '!important'
      },
      '.emoji-mart-anchor-bar': {
        position: 'absolute',
        bottom: -3,
        left: '0',
        width: '100%',
        height: 3,
        backgroundColor: theme.primaryColor + '!important'
      },
      '.emoji-mart-anchors i': {
        display: 'inline-block',
        width: '100%',
        maxWidth: 22
      },
      '.emoji-mart-anchors svg': {
        fill: 'currentColor',
        maxHeight: 18
      },
      '.emoji-mart-scroll': {
        overflowY: 'scroll',
        height: 270,
        padding: '0 6px 6px 6px',
        willChange: 'transform'
      },
      '.emoji-mart-search': {
        marginTop: 6,
        padding: '0 6px',
        display: 'none'
      },
      '.emoji-mart-search input': {
        fontSize: 16,
        display: 'block',
        width: '100%',
        padding: '.2em .6em',
        borderRadius: 25,
        border: '1px solid #d9d9d9',
        outline: '0'
      },
      '.emoji-mart-category .emoji-mart-emoji span': {
        zIndex: '1',
        position: 'relative',
        textAlign: 'center',
        cursor: 'pointer'
      },
      '.emoji-mart-category .emoji-mart-emoji:hover:before': {
        zIndex: '0',
        content: '""',
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        backgroundColor: '#f4f4f4',
        borderRadius: '100%'
      },
      '.emoji-mart-category-label': {
        fontSize: 12,
        marginTop: 4,
        zIndex: '2',
        position: 'sticky',
        fallbacks: [{
          position: '-webkit-sticky'
        }, {
          position: 'relative'
        }],
        top: '0'
      },
      '.emoji-mart-category-label span': {
        display: 'block',
        width: '100%',
        fontWeight: '500',
        padding: '5px 6px',
        backgroundColor: 'rgba(255, 255, 255, .95)',
        fallbacks: [{
          backgroundColor: '#fff'
        }]
      },
      '.emoji-mart-emoji': {
        position: 'relative',
        display: 'inline-block',
        fontSize: '0'
      },
      '.emoji-mart-no-results': {
        fontSize: 14,
        textAlign: 'center',
        paddingTop: 70,
        color: '#858585'
      },
      '.emoji-mart-no-results .emoji-mart-category-label': {
        display: 'none'
      },
      '.emoji-mart-no-results .emoji-mart-no-results-label': {
        marginTop: '.2em'
      },
      '.emoji-mart-no-results .emoji-mart-emoji:hover:before': {
        content: 'none'
      },
      '.emoji-mart-preview': {
        position: 'relative',
        height: 70
      },
      '.emoji-mart-preview-emoji, .emoji-mart-preview-data, .emoji-mart-preview-skins': {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)'
      },
      '.emoji-mart-preview-emoji': {
        left: 12
      },
      '.emoji-mart-preview-data': {
        left: 68,
        right: 12,
        wordBreak: 'break-all'
      },
      '.emoji-mart-preview-skins': {
        right: 30,
        textAlign: 'right'
      },
      '.emoji-mart-preview-name': {
        fontSize: 14
      },
      '.emoji-mart-preview-shortname': {
        fontSize: 12,
        color: '#888'
      },
      '.emoji-mart-preview-shortname + .emoji-mart-preview-shortname, .emoji-mart-preview-shortname + .emoji-mart-preview-emoticon, .emoji-mart-preview-emoticon + .emoji-mart-preview-emoticon': {
        marginLeft: '.5em'
      },
      '.emoji-mart-preview-emoticon': {
        fontSize: 11,
        color: '#bbb'
      },
      '.emoji-mart-title span': {
        display: 'inline-block',
        verticalAlign: 'middle'
      },
      '.emoji-mart-title .emoji-mart-emoji': {
        padding: '0'
      },
      '.emoji-mart-title-label': {
        color: '#999A9C',
        fontSize: 26,
        fontWeight: '300'
      },
      '.emoji-mart-skin-swatches': {
        fontSize: '0',
        padding: '2px 0',
        border: '1px solid #d9d9d9',
        borderRadius: 12,
        backgroundColor: '#fff'
      },
      '.emoji-mart-skin-swatches-opened .emoji-mart-skin-swatch': {
        width: 16,
        padding: '0 2px'
      },
      '.emoji-mart-skin-swatches-opened .emoji-mart-skin-swatch-selected:after': {
        opacity: '.75'
      },
      '.emoji-mart-skin-swatch': {
        display: 'inline-block',
        width: '0',
        verticalAlign: 'middle',
        transitionProperty: 'width, padding',
        transitionDuration: '.125s',
        transitionTimingFunction: 'ease-out'
      },
      '.emoji-mart-skin-swatch:nth-child(1)': {
        transitionDelay: '0s'
      },
      '.emoji-mart-skin-swatch:nth-child(2)': {
        transitionDelay: '.03s'
      },
      '.emoji-mart-skin-swatch:nth-child(3)': {
        transitionDelay: '.06s'
      },
      '.emoji-mart-skin-swatch:nth-child(4)': {
        transitionDelay: '.09s'
      },
      '.emoji-mart-skin-swatch:nth-child(5)': {
        transitionDelay: '.12s'
      },
      '.emoji-mart-skin-swatch:nth-child(6)': {
        transitionDelay: '.15s'
      },
      '.emoji-mart-skin-swatch-selected': {
        position: 'relative',
        width: 16,
        padding: '0 2px'
      },
      '.emoji-mart-skin': {
        display: 'inline-block',
        width: '100%',
        paddingTop: '100%',
        maxWidth: 12,
        borderRadius: '100%'
      },
      '.emoji-mart-skin-tone-1': {
        backgroundColor: '#ffc93a'
      },
      '.emoji-mart-skin-tone-2': {
        backgroundColor: '#fadcbc'
      },
      '.emoji-mart-skin-tone-3': {
        backgroundColor: '#e0bb95'
      },
      '.emoji-mart-skin-tone-4': {
        backgroundColor: '#bf8f68'
      },
      '.emoji-mart-skin-tone-5': {
        backgroundColor: '#9b643d'
      },
      '.emoji-mart-skin-tone-6': {
        backgroundColor: '#594539'
      }
    }
  };
};